import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../..';

export const selectSharedVideoForm = (state: RootState) => state.videos.form.shared;

export const selectSharedVideoPrivacy = createSelector(
    [selectSharedVideoForm],
    (form) => form.privacy.value
);

export const selectSharedVideoTitle = createSelector(
    [selectSharedVideoForm],
    (form) => form.title.value
);

export const selectSharedVideoDescription = createSelector(
    [selectSharedVideoForm],
    (form) => form.description.value
);

export const selectSharedVideoData = createSelector(
    [selectSharedVideoForm],
    (form) => ({
        privacy: form.privacy.value,
        title: form.title.value,
        description: form.description.value,
        base64Data: form.video.value
    })
);

export type SharedVideoData = ReturnType<typeof selectSharedVideoData>;
